// extracted by mini-css-extract-plugin
module.exports = {"logo":"WellsFargoLogoIcon__logo___2leTg","desktop":"WellsFargoLogoIcon__desktop___3sxW8","mobile":"WellsFargoLogoIcon__mobile___X6yMX"};